export enum WeekDay {
  MON = 'Mon',
  TUE = 'Tue',
  WED = 'Wed',
  THU = 'Thu',
  FRI = 'Fri',
  SAT = 'Sat',
  SUN = 'Sun',
}

export enum RecordStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  ARCHIVED = 'Archived',
  DELETED = 'deleted',
}

export enum scheduleOrderingHoursType {
  BUSINESS_HOURS = 'businessHours',
  CUSTOM = 'custom',
}

export enum OrderTimingType {
  PICKUP_SLOT = 'pickup-slot',
  SCHEDULE = 'schedule',
}

export enum Device {
  POS = 'Pos',
  MPOS = 'Mpos',
  KIOSK = 'Kiosk',
  QR = 'QR',
  ONLINE = 'Online',
  DOORDASH = 'Doordash',
  NUGGET = 'Nugget',
  Website = 'Website',
  MenuBoard = 'MenuBoard',
  TV = 'Tv',
  CATERING = 'Catering',
}

export enum ChannelVisibilityType {
  OnPrem = 'OnPrem',
  OffPrem = 'OffPrem',
  Custom = 'Custom',
}

export enum ModifierOptionPriceType {
  NoCharge = 'NoCharge',
  Individual = 'Individual',
  Group = 'Group',
}
export enum DayScheduleAvailabilityType {
  AllDay = 'AllDay',
  NotAvailable = 'NotAvailable',
  PartialDay = 'PartialDay',
  NoAvailability = 'No availability added',
}
export enum SCHEDULER_ACTIONS {
  PROCESS_ORDER = 'process_order',
  VERIFY_SCHEDULED_ORDER = 'verify_scheduled_order',
  DELETE_SCHEDULED_RULE = 'delete_scheduled_rule',
  CATERING_KDS = 'catering_kds',
  BREAKS_REMINDER = 'breaks_reminder',
  CATERING_PACKAGE_START = 'catering_package_start',
  CATERING_PACKAGE_END = 'catering_package_end',
  THIRD_PARTY_PROCESS_ORDER = 'third_party_process_order',
}
